import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import { SHORTCUTS } from '../lib/hotkeys';
import { Modal } from './Modal';

// The `?` sheet: what the keyboard does. Rendered straight off `SHORTCUTS`,
// which lives next to the listener that binds them (`lib/hotkeys.ts`) — a help
// screen kept apart from its handler is how a docs page ends up naming a key
// nothing listens for.

export function ShortcutSheet(props: {
  readonly open: boolean;
  readonly onClose: () => void;
}): JSX.Element {
  return (
    <Modal
      open={props.open}
      title={t('shortcuts.title')}
      desc={t('shortcuts.desc')}
      size="lg"
      onClose={props.onClose}
    >
      <dl class="shortcuts">
        <For each={SHORTCUTS}>
          {(shortcut) => (
            <div class="shortcuts__row">
              <dt class="shortcuts__keys">
                <For each={shortcut.combos}>
                  {(combo) => <kbd class="shortcuts__kbd">{combo}</kbd>}
                </For>
              </dt>
              <dd class="shortcuts__what">{t(shortcut.label)}</dd>
            </div>
          )}
        </For>
      </dl>
    </Modal>
  );
}
